export const IGetShareOptionsUseCaseType = Symbol('IGetShareOptionsUseCase');
